import { render, staticRenderFns } from "./ReportDashboard.vue?vue&type=template&id=6307b672&scoped=true"
import script from "./ReportDashboard.vue?vue&type=script&lang=js"
export * from "./ReportDashboard.vue?vue&type=script&lang=js"
import style0 from "./ReportDashboard.vue?vue&type=style&index=0&id=6307b672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6307b672",
  null
  
)

export default component.exports